import { render, staticRenderFns } from "./BookNew.vue?vue&type=template&id=54573436&scoped=true&"
import script from "./BookNew.vue?vue&type=script&lang=js&"
export * from "./BookNew.vue?vue&type=script&lang=js&"
import style0 from "./BookNew.vue?vue&type=style&index=0&id=54573436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54573436",
  null
  
)

export default component.exports